import { render, staticRenderFns } from "./CobDasboardDrill.vue?vue&type=template&id=0eb41a24&"
import script from "./CobDasboardDrill.vue?vue&type=script&lang=js&"
export * from "./CobDasboardDrill.vue?vue&type=script&lang=js&"
import style0 from "./CobDasboardDrill.vue?vue&type=style&index=0&id=0eb41a24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports